<script>
  import { format } from 'svelte-i18n';
  import { Tooltip } from '@sveltestrap/sveltestrap';

  import { Icon } from '@client/components/icon';

  import { SIGNATURE_WARNINGS } from '@client/enums';

  export let warnings = [];
  export let context = 'primary'; // 'primary' | 'reply'
  export let template = 'htmltemplate';
  export let onAddToFields = () => {};
  export let onFixInlineImages = () => {};

  const SHOWN_TYPES = new Set([
    SIGNATURE_WARNINGS.missing_params.id,
    SIGNATURE_WARNINGS.unused_params.id,
    SIGNATURE_WARNINGS.images_without_inline.id
  ]);
</script>

{#each warnings as { type, data }}
  {#if SHOWN_TYPES.has(type) && data.length}
    <div class="active-signature-fields">
      <b>
        {$format(SIGNATURE_WARNINGS[type]?.label)}
        <Icon name="help-circle" id="{type}-{context}-signature-fields" />
        <Tooltip target="{type}-{context}-signature-fields">
          {$format(SIGNATURE_WARNINGS[type].tooltip)}
        </Tooltip>
      </b>
      <div class="active-fields">
        {#if type === SIGNATURE_WARNINGS.images_without_inline.id}
          <div
            class="active-field"
            style="background-color: {SIGNATURE_WARNINGS[type].color}; color: var(--color-text);"
          >
            <span id="{type}-{context}-count-tooltip">
              {data.length}
              {$format('label.IMAGES')}
            </span>
            <Tooltip target="{type}-{context}-count-tooltip">
              <div class="warning-tooltip-content">
                <b>{$format(SIGNATURE_WARNINGS[type]?.label)} ({data.length})</b>
                <ul>
                  {#each data as item}
                    <li>{item}</li>
                  {/each}
                </ul>
              </div>
            </Tooltip>
            <Icon
              name="wrench"
              class="pointer"
              style="padding-left: var(--padding-base); border-left: 1px solid color-mix(in srgb, var(--color-text) 25%, transparent)"
              id="{type}-{context}-fix-tooltip"
              on:click={() => onFixInlineImages(template)}
              role="button"
              tabindex="0"
            />
            <Tooltip target="{type}-{context}-fix-tooltip">
              {$format('label.TOOLTIP.FIX_INLINE_IMAGES')}
            </Tooltip>
          </div>
        {:else}
          {#each data as item, index}
            <div
              class="active-field"
              data-testid="active-field-{item}"
              style="background-color: {SIGNATURE_WARNINGS[type].color}; color: #fff;"
            >
              {item}

              {#if type === SIGNATURE_WARNINGS.missing_params.id}
                <Icon
                  name="plus"
                  class="pointer"
                  style="padding-left: var(--padding-base); border-left: 1px solid rgba(255,255,255,0.25)"
                  id="{type}-{context}-{index}-fields-tooltip"
                  on:click={() => onAddToFields(item, type)}
                  role="button"
                  tabindex="0"
                />
                <Tooltip target="{type}-{context}-{index}-fields-tooltip">
                  {$format('label.TOOLTIP.ADD_TO_SIGNATURE_FIELDS')}
                </Tooltip>
              {/if}
            </div>
          {/each}
        {/if}
      </div>
    </div>
  {/if}
{/each}

<style lang="scss">
  .active-signature-fields {
    display: flex;
    flex-direction: column;
    gap: 8px;
    margin-top: var(--margin-large);

    .active-fields {
      align-items: center;
      display: flex;
      flex-wrap: wrap;
      gap: 8px;

      .active-field {
        background-color: var(--color-gray-300);
        border-radius: var(--border-radius-base);
        color: var(--color-text);
        display: flex;
        font-size: var(--font-size-small);
        gap: 8px;
        padding: var(--padding-small) var(--padding-base);
        position: relative;
        margin-bottom: var(--margin-small);
        text-decoration: none;
      }
    }
  }
</style>
